<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="align-items-center">
        <b-col>
          <h3 class="mb-0">
            จัดการ 2FA
          </h3>
          <p class="text-muted mb-0">
            รีเซ็ต / ปลดล็อก / เปิดสิทธิ์ลงทะเบียนให้ Agent, แอดมิน และบัญชีย่อย — เห็นเฉพาะยูสใหญ่
          </p>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body class="pt-0">
      <b-tabs
        v-model="tabIndex"
        pills
        class="mb-1"
        @input="onTabChange"
      >
        <b-tab
          v-for="tab in tabs"
          :key="tab.value"
          :title="tab.label"
        />
      </b-tabs>

      <p
        v-if="listError"
        class="text-danger"
      >
        {{ listError }}
      </p>

      <div class="d-flex justify-content-between flex-wrap">
        <b-form-group
          class="mb-1"
          label="ค้นหา"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="username หรือชื่อ"
              @keyup.enter="loadList"
            />
            <b-input-group-append>
              <b-button
                size="sm"
                variant="primary"
                :disabled="loading"
                @click="loadList"
              >
                ค้นหา
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </b-card-body>

    <b-overlay :show="loading" rounded="sm">
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        empty-text="ไม่พบข้อมูล"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <template #cell(enabled)="data">
          <b-badge :variant="data.item.enabled ? 'success' : 'secondary'">
            {{ data.item.enabled ? 'เปิดแล้ว' : 'ยังไม่เปิด' }}
          </b-badge>
        </template>
        <template #cell(setupAllowed)="data">
          <b-badge :variant="data.item.setupAllowed ? 'warning' : 'light'">
            {{ data.item.setupAllowed ? 'อนุญาตลงทะเบียน' : 'ยังไม่เปิดสิทธิ์' }}
          </b-badge>
        </template>
        <template #cell(locked)="data">
          <b-badge v-if="data.item.locked" variant="danger">
            ล็อกอยู่
          </b-badge>
          <span v-else class="text-muted">-</span>
        </template>
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <b-button
              v-if="!data.item.setupAllowed"
              size="sm"
              variant="outline-warning"
              class="mr-50 mb-50"
              :disabled="busyId === data.item.id"
              @click="setSetupAllowed(data.item, true)"
            >
              เปิดสิทธิ์ลงทะเบียน
            </b-button>
            <b-button
              v-else
              size="sm"
              variant="outline-secondary"
              class="mr-50 mb-50"
              :disabled="busyId === data.item.id"
              @click="setSetupAllowed(data.item, false)"
            >
              ปิดสิทธิ์ลงทะเบียน
            </b-button>
            <b-button
              v-if="data.item.locked"
              size="sm"
              variant="outline-info"
              class="mr-50 mb-50"
              :disabled="busyId === data.item.id"
              @click="unlock(data.item)"
            >
              ปลดล็อก
            </b-button>
            <b-button
              size="sm"
              variant="outline-danger"
              class="mb-50"
              :disabled="busyId === data.item.id"
              @click="confirmReset(data.item)"
            >
              รีเซ็ต 2FA
            </b-button>
          </div>
        </template>
      </b-table>
    </b-overlay>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
        label="Per Page"
        label-cols="8"
        label-align="left"
        label-size="sm"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>
      <b-pagination
        v-model="currentPage"
        :total-rows="items.length"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
} from 'bootstrap-vue'
import twoFactorApi from '@/api/twoFactor'

export default {
  components: {
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BPagination,
    BRow,
    BTab,
    BTable,
    BTabs,
  },
  data() {
    return {
      tabs: [
        { value: 'agent', label: 'Agent' },
        { value: 'admin', label: 'แอดมิน' },
        { value: 'subaccount', label: 'บัญชีย่อย' },
      ],
      tabIndex: 0,
      filter: '',
      items: [],
      listError: '',
      loading: false,
      busyId: null,
      perPage: 15,
      currentPage: 1,
      pageOptions: [10, 15, 25, 50],
      fields: [
        { key: 'index', label: '#' },
        { key: 'username', label: 'Username' },
        { key: 'name', label: 'ชื่อ' },
        { key: 'enabled', label: '2FA' },
        { key: 'setupAllowed', label: 'สิทธิ์ลงทะเบียน' },
        { key: 'locked', label: 'ล็อก OTP' },
        { key: 'actions', label: 'จัดการ' },
      ],
    }
  },
  computed: {
    accountType() {
      return this.tabs[this.tabIndex].value
    },
  },
  created() {
    this.loadList()
  },
  methods: {
    toast(message, variant) {
      this.$bvToast.toast(message, {
        title: 'จัดการ 2FA',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
    errorMessage(error) {
      return (error.response && error.response.data && error.response.data.message) || 'ทำรายการไม่สำเร็จ'
    },
    onTabChange() {
      this.currentPage = 1
      this.loadList()
    },
    async loadList() {
      this.loading = true
      this.listError = ''
      try {
        const { data } = await twoFactorApi.manageList(this.accountType, this.filter)
        this.items = (data && data.accounts) || []
      } catch (error) {
        this.items = []
        this.listError = this.errorMessage(error)
        this.toast(this.listError, 'danger')
      } finally {
        this.loading = false
      }
    },
    async setSetupAllowed(item, allowed) {
      this.busyId = item.id
      try {
        const { data } = await twoFactorApi.manageAllowSetup(item.accountType, item.id, allowed)
        this.toast(
          (data && data.message) || (allowed ? 'เปิดสิทธิ์แล้ว' : 'ปิดสิทธิ์แล้ว'),
          'success',
        )
        await this.loadList()
      } catch (error) {
        this.toast(this.errorMessage(error), 'danger')
      } finally {
        this.busyId = null
      }
    },
    async unlock(item) {
      this.busyId = item.id
      try {
        const { data } = await twoFactorApi.manageUnlock(item.accountType, item.id)
        this.toast((data && data.message) || 'ปลดล็อกแล้ว', 'success')
        await this.loadList()
      } catch (error) {
        this.toast(this.errorMessage(error), 'danger')
      } finally {
        this.busyId = null
      }
    },
    async confirmReset(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `รีเซ็ต 2FA ของ ${item.username} ? รหัสในแอปเดิมใช้ไม่ได้ และเซสชันหลังบ้านจะถูกตัด`,
        {
          title: 'ยืนยันรีเซ็ต 2FA',
          okTitle: 'รีเซ็ต',
          cancelTitle: 'ยกเลิก',
          okVariant: 'danger',
        },
      )
      if (!ok) return

      this.busyId = item.id
      try {
        const { data } = await twoFactorApi.manageReset(item.accountType, item.id)
        this.toast((data && data.message) || 'รีเซ็ตแล้ว', 'success')
        await this.loadList()
      } catch (error) {
        this.toast(this.errorMessage(error), 'danger')
      } finally {
        this.busyId = null
      }
    },
  },
}
</script>
